// src/services/weatherService.js
import axios from "axios";

// --- Real API Data Fetching ---
const API_KEY = "69daa4c50206228bdadf295da5ff9bf8";
const BASE_URL = "https://api.openweathermap.org/data/3.0/onecall";
const USE_MOCK = process.env.REACT_APP_USE_MOCK_DATA === "true";

/**
 * Fetches comprehensive weather data from OpenWeatherMap.
 * @param {number} lat - Latitude of the location.
 * @param {number} lon - Longitude of the location.
 * @param {string} lang - Language for the response (e.g., 'en', 'ar').
 * @returns {Promise<object>} A promise that resolves to the weather data.
 */
const getRealWeatherData = (lat, lon, lang = "en") => {
  const params = {
    lat,
    lon,
    appid: API_KEY,
    units: "metric",
    lang,
    exclude: "minutely",
  };
  return axios.get(BASE_URL, { params });
};

// --- Mock Data for Testing ---
const mockData = {
  lat: 30.75,
  lon: 30.69,
  timezone: "Africa/Cairo",
  current: {
    /* ... your mock 'current' data ... */
  },
  hourly: [
    /* ... your mock 'hourly' data ... */
  ],
  daily: Array.from({ length: 8 }, (_, i) => ({
    dt: 1756044000 + i * 86400, // Starts from Aug 24, 2025
    humidity: 60 + i,
    temp: { min: 22 + i * 0.2, max: 31 - i * 0.5 },
    weather: [{ description: "scattered clouds", icon: "03d" }],
  })),
};

const getMockWeatherData = () => {
  console.log("--- Using Mock Weather Service ---");
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: mockData });
    }, 500);
  });
};

// --- Exported Service Function ---
// This function decides whether to return real or mock data based on the .env flag
export const getWeatherData = (lat, lon, lang) => {
  if (USE_MOCK) {
    return getMockWeatherData();
  }
  return getRealWeatherData(lat, lon, lang);
};
